import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
function Popover(props) {
    var _a, _b, _c;
    const ref = useRef(null);
    const popoverRef = useRef(null);
    const visible = useRef((_a = props.showOnInit) !== null && _a !== void 0 ? _a : false);
    const toggle = () => {
        visible.current = !visible.current;
        update();
    };
    const update = () => {
        var _a, _b;
        const triggerEl = ref.current;
        const popEl = popoverRef.current;
        if (!triggerEl || !popEl)
            return;
        const rect = triggerEl.getBoundingClientRect();
        const scrollTop = window.scrollY;
        const scrollLeft = window.scrollX;
        const baseTop = rect.top + scrollTop;
        const baseLeft = rect.left + scrollLeft;
        const pos = {
            top: baseTop + rect.height,
            left: baseLeft + rect.width / 2 - popEl.offsetWidth / 2
        };
        const placements = {
            top: () => {
                pos.top = baseTop - popEl.offsetHeight;
            },
            left: () => {
                pos.top = baseTop + rect.height / 2 - popEl.offsetHeight / 2;
                pos.left = baseLeft - popEl.offsetWidth;
            },
            right: () => {
                pos.top = baseTop + rect.height / 2 - popEl.offsetHeight / 2;
                pos.left = baseLeft + rect.width;
            },
            bottom: () => { }
        };
        const placement = (_a = props.postion) !== null && _a !== void 0 ? _a : 'bottom';
        (_b = placements[placement]) === null || _b === void 0 ? void 0 : _b.call(placements);
        if (visible.current) {
            Object.assign(popEl.style, {
                top: `${pos.top}px`,
                left: `${pos.left}px`,
                display: 'block'
            });
            popEl.classList.add('fade', 'show');
        }
        else {
            popEl.style.display = 'none';
            popEl.classList.remove('show');
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current &&
                !popoverRef.current.contains(event.target) &&
                ref.current &&
                !ref.current.contains(event.target)) {
                visible.current = false;
                update();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    return (_jsxs(_Fragment, { children: [props.trigger({ ref, onClick: toggle }), _jsxs("div", { ref: popoverRef, className: `popover bs-popover-${props.postion} ${(_b = props.className) !== null && _b !== void 0 ? _b : ''}`.trim(), style: Object.assign({ position: 'absolute', display: 'none', transition: 'opacity 0.15s ease-in-out' }, props.style), children: [_jsx("div", { className: "popover-arrow" }), _jsx("div", { className: `popover-body ${(_c = props.bodyClassName) !== null && _c !== void 0 ? _c : ''}`.trim(), style: props.bodyStyle, children: props.children })] })] }));
}
export default Popover;
